module.exports = __webpack_public_path__ + "img/ulbs.0cc976ab.svg";